var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49998 17.4168C13.8722 17.4168 17.4166 13.8724 17.4166 9.50016C17.4166 5.12791 13.8722 1.5835 9.49998 1.5835C5.12772 1.5835 1.58331 5.12791 1.58331 9.50016C1.58331 13.8724 5.12772 17.4168 9.49998 17.4168ZM10.0937 7.12516C10.0937 6.79725 9.82789 6.53141 9.49998 6.53141C9.17207 6.53141 8.90623 6.79725 8.90623 7.12516V8.90641H7.12498C6.79706 8.90641 6.53123 9.17225 6.53123 9.50016C6.53123 9.82807 6.79706 10.0939 7.12498 10.0939H8.90623V11.8752C8.90623 12.2031 9.17207 12.4689 9.49998 12.4689C9.82789 12.4689 10.0937 12.2031 10.0937 11.8752V10.0939H11.875C12.2029 10.0939 12.4687 9.82807 12.4687 9.50016C12.4687 9.17225 12.2029 8.90641 11.875 8.90641H10.0937V7.12516Z",
    fill: "#1E1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.2f4f94c048c331d5ae37caf3a2c92236.svg";
export { ForwardRef as ReactComponent };